import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { Schemy } from '@stetamalo/cloud-platform/lib/schemy';
import { ApiConfig } from 'services/support/utils/types/api-config';
import { Lashitas, LashitasCreate } from '../../entities/lashitas';

export type Interface = ApiInterface<{
  response: Lashitas;
  pathParams: { lashitasId: string };
  body: Omit<LashitasCreate, 'tenantId' | 'createdAt' | 'updatedAt'>;
  claims: { tenantId: string };
  queryParams: EmptyObject;
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-update-lashitas',
  method: 'PUT',
  basePath: 'lashitas',
  path: '/{lashitasId}',
  tablePermission: 'readWrite',
  scope: 'ADMIN',
  schema: Schemy.schema<Interface['body']>({
    alias: { type: String, required: false },
    firstName: { type: String, required: false },
    lastName: { type: String, required: false },
    phone: { type: String, required: false },
    info: {
      type: {
        uriAvatar: { type: String, required: false },
        color: { type: String, required: false },
        sex: { type: String, required: false },
        state: { type: String, required: false },
        city: { type: String, required: false },
        colony: { type: String, required: false },
        street: { type: String, required: false },
        zipCode: { type: String, required: false },
        outerNumber: { type: String, required: false },
        innerNumber: { type: String, required: false },
      },
      required: false,
    },
    schedulePosition: { type: Number, required: false },
    status: { type: String, enum: ['ACTIVE', 'INACTIVE'], required: false, default: 'ACTIVE' },
  }),
};
